import { Tabs, Radio } from 'antd';
import React from 'react';
import EditableFormTable from './editabletable';

const { TabPane } = Tabs;

class SwitcheredTables extends React.Component {
    tabConfigs = [
       {
        key : "1", 
        name : "Groupmembers"
       },
       {
        key : "2", 
        name : "User Location"
       },
       {
        key : "3", 
        name : "HR Info"
       } 

    ]
    getColumnConfigs =(key)=>{
        switch (key) {
            case '1':
              return {
                hardCodedInserts : ()=>{
                    return [ 
                            { columnName: "G_NAME", columnValue: 'SSOUSERS' },
                            { columnName: "CREATE_DATE", columnValue: new Date().toLocaleDateString('en-US')},
                            { columnName: "CREATED_BY", columnValue: 'MANUAL' },
                            { columnName: "APPLICATION", columnValue: 'Whole Child' },
                         ]
                },
                indexToInsert :'SEC_GROUPMEMBERS_F',
                queryToGet : "list_sec_group_f",
                columns : [
                {
                title: "G_MEMBER",
                dataIndex: "G_MEMBER",
                width: "25%",
                editable: true,
                disableOnEditScreen: true,
                deleteFilter : true,
                customValidate: function(value){
                  return value.toLocaleUpperCase()
                }
              },
              {
                title: "EMPLOYEE_ID",
                dataIndex: "EMPLOYEE_ID",
                width: "15%",
                inputType: "number",
                editable: true,
                disableOnEditScreen: true,
                deleteFilter : true,
                validationRules: [
                  {
                    required: true,
                    message: "Employee ID is required!",
                  },
                  {
                    type: "number",
                    message: "Employee ID must be a number!",
                  },
                  {
                    pattern: /^[0-9]+$/,
                    message: "Employee ID must be numeric!",
                  },
                ],
              },
              {
                title: "G_ROLE",
                dataIndex: "G_ROLE",
                width: "40%",
                editable: true,
                inputType: "dropdown",
                dropDownValues : [
                    "DISTRICT_ADMIN",
                    "DEVELOPER",
                    "ASST_PRINCIPAL",
                    "CO-TEACHER",
                    "TEACHER",
                    "PRINCIPAL",
                    "INTERVENTIONIST",
                    "COUNSELOR"
                  ],
              }
            ]}
            case '2':
              return {
                  hardCodedInserts : (row)=>{
                    let alterNames = { "CAMPUS_CODE": "SITE_CAMPUS_CODE" , "SCHOOL_ID" : 'LOCATION_ID', "SCHOOL_TYPE_DESCR" : "SCHOOL_LEVEL_TYPE_DESCR"};
                      let toReturn  =[
                        { columnName: "STATUS", columnValue: 'ACTIVE' },
                        { columnName: "CREATED_DATE", columnValue: new Date().toLocaleDateString('en-US')},
                        { columnName: "LAST_UPDATED_DATE", columnValue: new Date().toLocaleDateString('en-US')},
                        { columnName: "CREATED_BY", columnValue: 'DBT_USER' },
                        { columnName: "LAST_UPDATED_BY", columnValue: 'DBT_USER' },
                        { columnName: "APPLICATION", columnValue: 'Whole Child' },
                      ];
                        let employeeIdMatched = window.landing_reports["g_member_data_landing"].find(e=> e.G_MEMBER.toUpperCase() == row.USER_LOGON.toUpperCase());
                        let id = employeeIdMatched ? employeeIdMatched.EMPLOYEE_ID : '';
                        let schoolObjecs = window.landing_reports["school_campus_data_landing"].find(e=> e.SCHOOL_NAME.toUpperCase() == row.SITE_CAMPUS_NAME.toUpperCase())
                        let objs = Object.keys(alterNames).map(e=>{
                            return  { columnName: alterNames[e], columnValue: schoolObjecs[e]+""}
                        });
                        toReturn = [...toReturn, ...objs, {columnName : 'EMPLOYEE_ID', columnValue : id}]
                      return toReturn
                  },
                  indexToInsert :'SEC_ER_USER_LOCATION_F',
                  queryToGet : "list_sec_er_user_location_f",
                  combinedFilters : true,
                  columns : [
                  {
                  title: "USER_LOGON",
                  dataIndex: "USER_LOGON",
                  width: "35%",
                  dropdownWidth:"320px",
                  editable: true,
                  deleteFilter : true,
                  inputType: "dropdown",
                  asyncDropdownValues : {
                    reportName  :  'g_member_data_landing',
                    column : 'G_MEMBER',
                    setReportInWindowVar : true
                  }
                },
                {
                  title: "ACCESS_LEVEL",
                  dataIndex: "ACCESS_LEVEL",
                  width: "30%",
                  editable: true,
                  inputType: "dropdown",
                  dropDownValues : [
                     "S"
                    ],
                },
                {
                  title: "SCHOOL_NAME",
                  dataIndex: "SITE_CAMPUS_NAME",
                  width: "30%",
                  editable: true,
                  inputType: "dropdown",
                  deleteFilter : true,
                  asyncDropdownValues : {
                    reportName  :  'school_campus_data_landing',
                    column : 'SCHOOL_NAME',
                    setReportInWindowVar : true
                  }
                  
                },
              ]}
            case '3':
              return {
                  hardCodedInserts : (row)=>{
                      Object.keys(row).map(p=>{
                        row[p] = row[p] ? row[p] : ''
                      });
                      let alterNames = { "CAMPUS_CODE": "SITE_CAMPUS_CODE" , "SCHOOL_NAME" : "LOCATION_NAME","SCHOOL_ID" : 'LOCATION_CODE', "SCHOOL_TYPE_DESCR" : "SCHOOL_LEVEL_TYPE_DESCR"};
                      let toReturn = [ 
                              { columnName: "CREATE_DATE", columnValue: new Date().toLocaleDateString('en-US')},
                              { columnName: "CREATED_BY", columnValue: 'MANUAL' }
                            ];

                      // let employeeIdMatched = window.landing_reports["g_member_data_landing"].find(e=> e.EMPLOYEE_ID.toUpperCase() == row.EMPLOYEE_NUM_CODE.toUpperCase());
                      // let id = employeeIdMatched ? employeeIdMatched.EMPLOYEE_ID : '';
                      let schoolObjecs = window.landing_reports["school_campus_data_landing"].find(e=> e.SCHOOL_NAME.toUpperCase() == row.SITE_CAMPUS_NAME.toUpperCase())
                      let objs = Object.keys(alterNames).map(e=>{
                          return  { columnName: alterNames[e], columnValue: schoolObjecs ? schoolObjecs[e]+"": ''}
                      });
                      toReturn = [...toReturn, ...objs]
                    return toReturn
                  },
                  indexToInsert :'SEC_WC_USER_HR_INFO_F',
                  queryToGet : "list_sec_wc_user_hr_info_f",
                  columns : [
                    {
                      title: "EMPLOYEE_NUM_CODE",
                      dataIndex: "EMPLOYEE_NUM_CODE",
                      width: "15%",
                      dropdownWidth:"320px",
                      editable: true,
                      disableOnEditScreen : true,
                      deleteFilter : true,
                      inputType: "dropdown",
                      aliasColumns:{
                        valuetoInsert: "EMPLOYEE_NUM_CODE",
                        valuetoChange: "G_MEMBER",
                        valueColumn:"EMPLOYEE_ID",
                      },
                      asyncDropdownValues : {
                        reportName  :  'g_member_data_landing',
                        column : 'G_MEMBER',
                        setReportInWindowVar : true,
                        dropdownFilters: {
                          sourceKey: "EMPLOYEE_ID",
                          targetKey: "EMPLOYEE_NUM_CODE"
                        },
                      }
                    },
                    {
                      title: "FIRST_NAME",
                      dataIndex: "FIRST_NAME",
                      width: "10%",
                      editable: true,
                      customValidate: function(value){
                        return value.substring(0, 1).toUpperCase() + value.substring(1).toLowerCase();
                      }
                    },
                    {
                      title: "LAST_NAME",
                      dataIndex: "LAST_NAME",
                      width: "10%",
                      editable: true,
                      customValidate: function(value){
                        return value.substring(0, 1).toUpperCase() + value.substring(1).toLowerCase();
                      }
                    },
                    {
                      title: "SCHOOL_NAME",
                      dataIndex: "SITE_CAMPUS_NAME",
                      width: "20%",
                      editable: true,
                      isNotRequired : true,
                      inputType: "dropdown",
                      // deleteFilter : true,
                      asyncDropdownValues : {
                        reportName  :  'school_campus_data_landing',
                        column : 'SCHOOL_NAME',
                        setReportInWindowVar : true
                      }
                    },
                    { 
                      title: "JOB_TITLE_NAME",
                      dataIndex: "JOB_TITLE_NAME",
                      width: "20%",
                      editable: true,
                      inputType: "dropdown",
                      dropDownValues : [
                        "DISTRICT_ADMIN",
                        "DEVELOPER",
                        "ASST_PRINCIPAL",
                        "PRINCIPAL",
                        "TEACHER",
                        "COUNSELOR",
                        "INTERVENTIONIST"
                      ],
                    },
                    {
                      title: "G_ROLE",
                      dataIndex: "G_ROLE",
                      width: "20%",
                      editable: true,
                      inputType: "dropdown",
                      dropDownValues : [
                        "DISTRICT_ADMIN",
                        "DEVELOPER",
                        "ASST_PRINCIPAL",
                        "PRINCIPAL",
                        "TEACHER",
                        "COUNSELOR",
                        "INTERVENTIONIST"
                      ],
                    }
              ]}
        }
    }
  render() {
    const { isModalVisible } = this.props;
    return (
      <div>
        <Tabs defaultActiveKey="1" size={"large"} destroyInactiveTabPane>
        {this.tabConfigs.map(({key, name}) => (
          <TabPane tab={name} key={key}>
          <EditableFormTable visibilityKey={key} modalVisibility = {isModalVisible} {...this.getColumnConfigs(key)}  />
          </TabPane>
           ))}
        </Tabs>
      </div>
    );
  }
}



export default SwitcheredTables;